// extracted by mini-css-extract-plugin
module.exports = {"layoutSwitcherContainer":"_1UmTF","hideOnMobile":"_2d9NF"};